var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroSectionArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 153,
    viewBox: "0 0 179 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8105 87.3317C67.324 87.2903 65.8321 87.2354 64.5786 87.1175C42.2093 85.1308 18.6773 76.9133 1.20246 62.7924C0.572561 62.275 0.432005 61.3564 0.949271 60.7172C1.46653 60.078 2.36459 59.9946 2.99499 60.5131C20.152 74.2185 43.053 82.2181 64.8643 84.1505C65.5644 84.2244 66.3817 84.2609 67.2007 84.302C66.5776 82.5964 66.53 80.9853 66.8229 79.5394C67.3264 77.3648 68.7308 75.4165 70.6887 73.8126C73.4349 71.5788 77.1562 70.0402 80.8462 69.3323C83.6873 68.8168 86.5014 68.8418 88.5334 69.5113C90.2296 70.0255 91.4467 70.9645 92.136 72.2176C92.856 73.5398 92.9748 75.3103 91.9806 77.5824C90.3704 81.4745 86.9278 83.9452 82.652 85.4387C79.5301 86.5246 76.0211 87.0374 72.6407 87.2396C73.3769 87.9968 74.2571 88.7768 75.2827 89.5845C83.2593 95.5316 97.2773 98.2504 112.625 98.8499C135.976 99.7404 162.445 95.623 175.632 89.8492C176.303 89.5558 177.243 89.87 177.576 90.6194C177.908 91.3689 177.508 92.2713 176.837 92.5648C163.314 98.4859 136.364 102.721 112.48 101.832C96.4486 101.195 81.7742 98.2031 73.5238 91.9396C71.4835 90.3488 69.8777 88.8349 68.8105 87.3317ZM70.4267 84.3552C69.6379 82.8779 69.4266 81.4995 69.6644 80.2302C70.0347 78.6579 71.154 77.2698 72.5189 76.1345C74.869 74.2112 78.1516 72.8846 81.3499 72.272C83.5715 71.8645 85.8083 71.7932 87.4788 72.2494C88.3987 72.518 89.1181 72.9343 89.5442 73.5941C89.8653 74.3179 89.745 75.2521 89.3225 76.4058C87.9244 79.5725 85.0286 81.4683 81.6747 82.633C78.2044 83.8361 74.0186 84.3288 70.4267 84.3552Z",
    fill: "url(#paint0_linear_912_324)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.02639 60.6558C9.06407 66.745 13.4354 75.0935 15.8698 83.2895C16.0882 84.0828 15.6538 84.9082 14.9431 85.1113C14.1214 85.365 13.2619 84.9335 13.0439 84.1413C10.6875 76.4219 6.63756 68.4953 0.890488 62.7604C0.356778 62.159 0.343306 61.2254 0.893715 60.6609C1.55614 60.0481 2.49268 60.0544 3.02639 60.6558Z",
    fill: "url(#paint1_linear_912_324)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.81512 60.2844C10.177 63.9431 19.3681 62.6969 27.0197 60.3892C27.7304 60.1861 28.5897 60.619 28.8082 61.4124C29.0261 62.2046 28.5905 63.0291 27.7683 63.2817C19.5225 65.7542 9.50165 66.932 1.46065 62.946C0.757323 62.5639 0.48963 61.659 0.836504 60.9366C1.18288 60.213 2.11228 59.9035 2.81512 60.2844Z",
    fill: "url(#paint2_linear_912_324)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_912_324",
    x1: 40.9603,
    y1: 152.837,
    x2: 46.5038,
    y2: -3.2116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_912_324",
    x1: 11.4212,
    y1: 86.6864,
    x2: 21.8024,
    y2: 77.9308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_912_324",
    x1: 5.63999,
    y1: 73.1103,
    x2: 4.3795,
    y2: 51.4704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroSectionArrow);
export default __webpack_public_path__ + "static/media/heroSectionArrow.9a3202b12ddf5e2c5e7e25f3977c4561.svg";
export { ForwardRef as ReactComponent };